import { OnDestroy, inject, Service } from '@angular/core';
import { LocalStorageService } from '@core/providers/storage/local-storage.service';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { IntercomService } from '@core/providers/backend/intercom.service';
import { RolesService } from '@core/providers/backend/roles.service';
import { ServerEnvironmentService } from '@core/providers/server-environment/server-environment.service';
import { UserService } from '@core/providers/user/user.service';
import { CONSTANTS } from '@shared/constants';

@Service()
export class LogoutService implements OnDestroy {
  private userService = inject(UserService);
  private localStorage = inject(LocalStorageService);
  private intercomService = inject(IntercomService);
  private rolesService = inject(RolesService);
  private serverEnvironmentService = inject(ServerEnvironmentService);

  private onDestroy$ = new Subject<void>();

  logOut(): void {
    this.serverEnvironmentService
      .getServerEnvironmentConfig$()
      .pipe(first(), takeUntil(this.onDestroy$))
      .subscribe(config => {
        const desiredLocation = `${window.location.origin}/login`;
        const logOutPath = `https://${config.auth0.domain}/v2/logout?returnTo=${encodeURIComponent(`${desiredLocation}`)}`;

        localStorage.removeItem(CONSTANTS.AUTH.ID_TOKEN);
        this.localStorage.clear();
        sessionStorage.clear();
        this.userService.setLoggedIn(false);
        this.userService.setAuthorizedData();
        this.rolesService.clearRoles();
        this.intercomService.shutdownIntercom();
        window.location.href = logOutPath;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
